import {
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,
    USER_LOADED_REQUEST,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,
    SINGLE_USER_DETAILS_REQUEST,
    SINGLE_USER_DETAILS_SUCCESS,
    SINGLE_USER_DETAILS_FAIL,
    USER_LIST_RESET,
    SINGLE_USER_UPDATE_REQUEST,
    SINGLE_USER_UPDATE_SUCCESS,
    SINGLE_USER_UPDATE_FAIL,
    SINGLE_USER_UPDATE_RESET,
    MAKER_LIST_REQUEST,
    MAKER_LIST_SUCCESS,
    MAKER_LIST_FAIL,
    MAKER_LIST_RESET,
    ADMIN_LIST_REQUEST,
    ADMIN_LIST_SUCCESS,
    ADMIN_LIST_FAIL,
    ADMIN_LIST_RESET,
    SINGLE_USER_DELETE_REQUEST,
    SINGLE_USER_DELETE_SUCCESS,
    SINGLE_USER_DELETE_FAIL,
    USER_REPORT_REQUEST,
    USER_REPORT_SUCCESS,
    USER_REPORT_FAIL,
    USER_REPORT_LIST_REQUEST,
    USER_REPORT_LIST_SUCCESS,
    USER_REPORT_LIST_FAIL,
    USER_REPORT_LIST_RESET,
    USER_SINGLE_REPORT_REQUEST,
    USER_SINGLE_REPORT_SUCCESS,
    USER_SINGLE_REPORT_FAIL,
    USER_REPORT_DELETE_REQUEST,
    USER_REPORT_DELETE_SUCCESS,
    USER_REPORT_DELETE_FAIL,
    USER_REGISTER_RESET,
} from '../constants/AuthConstants';



// USER CONTROLLER

export const authInfoReducer = (state = {}, { type, payload}) => {

    switch (type) {
        case USER_LOADED_REQUEST:
            return {
                loading: true
            }
        case USER_LOADED_SUCCESS:
            return {
                loading: false,
                authInfo: payload
            }
        case USER_LOADED_FAIL: 
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}



export const authLoginReducer = (state = {}, { type, payload}) => {

    switch (type) {
        case USER_LOGIN_REQUEST:
            return {
                loading: true
            }
        case USER_LOGIN_SUCCESS:
            return {
                loading: false,
                info: payload,
               
            }
        case USER_LOGIN_FAIL: 
            return {
                loading: false,
                error: payload
            }
        case USER_LOGOUT:
            return {}

        default:
            return state;
    }
}



export const authRegisterReducer = (state = {}, { type, payload}) => {

    switch (type) {
        case USER_REGISTER_REQUEST:
            return {
                loading: true,
            }
        case USER_REGISTER_SUCCESS:
            return {
                loading: false,
                info: payload
            }
        case USER_REGISTER_FAIL: 
            return {
                loading: false,
                error: payload
            }
        case USER_REGISTER_RESET:
            return {
                loading: false,
                info: {}
            }
        case USER_LOGOUT:
            return {}
            
        default:
            return state;
    }
}


export const authUpdateProfileReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case USER_UPDATE_PROFILE_REQUEST:
            return {
                loading: true
            }

        case USER_UPDATE_PROFILE_SUCCESS:
            return {
                loading: false,
                success: true,
                info: payload
            }

        case USER_UPDATE_PROFILE_FAIL:
            return {
                loading: false,
                error: payload
            }

        case USER_UPDATE_PROFILE_RESET:
            return {}
        
        default:
            return state;
    }
}









// ADMIN CONTROLLER


export const authUserReducer = (state = { users: [] }, { type, payload }) => {

    switch (type) {
        case USER_LIST_REQUEST:
            return {
                loading: true,
                users: []
            }
        
        case USER_LIST_SUCCESS:
            return {
                loading: false,
                users: payload
            }

        case USER_LIST_FAIL:
            return {
                loading: false,
                error: payload
            }

        case USER_LIST_RESET:
            return { 
                users: [] 
            }

        default:
            return state;
    }
}


export const authMakerReducer = (state = { makers: [] }, { type, payload }) => {

    switch (type) {
        case MAKER_LIST_REQUEST:
            return {
                loading: true,
                makers:[]
            }
        
        case MAKER_LIST_SUCCESS:
            return {
                loading: false,
                makers: payload
            }

        case MAKER_LIST_FAIL:
            return {
                loading: false,
                error: payload
            }

        case MAKER_LIST_RESET:
            return { 
                makers: [] 
            }

        default:
            return state;
    }
}


export const authAdminReducer = (state = { admins: [] }, { type, payload }) => {

    switch (type) {
        case ADMIN_LIST_REQUEST:
            return {
                loading: true,
                admins: []
            }
        
        case ADMIN_LIST_SUCCESS:
            return {
                loading: false,
                admins: payload
            }

        case ADMIN_LIST_FAIL:
            return {
                loading: false,
                error: payload
            }

        case ADMIN_LIST_RESET:
            return { 
                admins: [] 
            }

        default:
            return state;
    }
}


export const singleUserDetailsReducer = (state = { user: [] }, { type, payload }) => {

    switch (type) {
        case SINGLE_USER_DETAILS_REQUEST:
            return {
                loading: true,
            }
        
        case SINGLE_USER_DETAILS_SUCCESS:
            return {
                loading: false,
                user: payload
            }

        case SINGLE_USER_DETAILS_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}


export const singleUserUpdateReducer = (state = { user: {}}, { type, payload }) => {

    switch (type) {
        case SINGLE_USER_UPDATE_REQUEST:
            return {
                loading: true
            }
        
            case SINGLE_USER_UPDATE_SUCCESS:
                return {
                    loading: false,
                    success: true
                }
            case SINGLE_USER_UPDATE_FAIL:
                return {
                    loading: false,
                    error: payload
                }
            
            case SINGLE_USER_UPDATE_RESET:
                return {
                    user: {}
                }

        default:
            return state;
    }
}


export const singleUserDeleteReducer = (state = { user: {}}, { type, payload }) => {

    switch (type) {
        case SINGLE_USER_DELETE_REQUEST:
            return {
                loading: true
            }
        
            case SINGLE_USER_DELETE_SUCCESS:
                return {
                    loading: false,
                    success: true
                }
            case SINGLE_USER_DELETE_FAIL:
                return {
                    loading: false,
                    error: payload
                }
            
        default:
            return state;
    }
}



export const postUserReportReducer = (state = {  }, { type, payload }) => {

    switch (type) {
        case USER_REPORT_REQUEST:
            return {
                loading: true
            }

        case USER_REPORT_SUCCESS:
            return {
                loading: false,
                success: payload
            }
        case USER_REPORT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const getUserReportReducer = (state = { reports: [] }, { type, payload }) => {

    switch (type) {
        case USER_REPORT_LIST_REQUEST:
            return {
                loading: true,
                reports: []
            }

        case USER_REPORT_LIST_SUCCESS:
            return {
                loading: false,
                reports: payload
            }

        case USER_REPORT_LIST_FAIL:
            return {
                loading: false,
                error: payload
            }

        case USER_REPORT_LIST_RESET:
            return {
                reports: []
            }

        default:
            return state;
    }
}




export const getUserReportOneReducer = (state = { report: {} }, { type, payload }) => {

    switch (type) {
        case USER_SINGLE_REPORT_REQUEST:
            return {
                loading: true,
                report: {}
            }

        case USER_SINGLE_REPORT_SUCCESS:
            return {
                loading: false,
                report: payload
            }

        case USER_SINGLE_REPORT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}


export const getUserReportDeleteReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case USER_REPORT_DELETE_REQUEST:
            return {
                loading: true
            }

        case USER_REPORT_DELETE_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case USER_REPORT_DELETE_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}
